import React from 'react'
import Helmet from 'react-helmet'

import Work from '../components/work'

const goose = require('../img/goose.jpg')

const Goose = () =>
  <div>
    <Helmet
      title='Goose | Cory Schadt'
      bodyAttributes={{
        class: 'inner'
      }}
    />

    <div className='page fade'>
      <div className='container'>
        <div className='content'>
          <h1>Goose</h1>
          <div className='text'>
            <p>Goose is travel insurance made easy.</p>
            <p>Primary Role:  HTML, CSS, Responsive Design, WordPress Theme Creation.</p>
            <p><a className='btn' target='_blank' href='https://www.gooseinsurance.com/'>View Project</a></p>
          </div>
        </div>
      </div>

      <div className='project-feature'>

        <Work noLink raise laptop screen={goose} color='#F13697' />

      </div>

    </div>
  </div>
export default Goose



// WEBPACK FOOTER //
// ./src/pages/goose.js